





























import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import IndexMixin from '../mixins/indexMixin'
// import * as utils from '@/filters/utils'
import { getAnswerDetail, getExamDetail, startExam, getSubject, submitRecord, endExam as finishExam } from '@/modules/exam/api/index'
import * as utils from '../filters/utils'
import headerInfo from './components/header.vue'
import subjectList from './components/subject-list.vue'
import bottomInfo from './components/bottom.vue'
import { eventBus } from '@/modules/exam/filters/event-bus'

@Component({
  components: {
    headerInfo,
    subjectList,
    bottomInfo
  }
})
export default class ClassWrap extends Mixins(IndexMixin) {
  // @Prop() id!: any
  isLoading: boolean = false
  isSubLoading: boolean = false
  errorObj: any = null
  answerCardDetail: any = {}
  examDetail: any = {}
  curAnswer: any = null // 当前题目答案的暂存区
  isSubmitting: boolean = false

  created() {
    this.$store.dispatch('resetStateData')
    this.initEvent()
    this.initPage()
  }

  initEvent() {
    eventBus.$off()
    // 切换题目
    eventBus.$on('index.changeSubject', async (subject: any) => {
      if (this.isSubLoading || this.isSubmitting) return
      this.isSubLoading = true
      try {
        if (this.hasPendingAnswer()) await this.submitRecord()
        this.getSubject(subject.id)
      } catch {
        this.isSubLoading = false
        this.$message({type: 'error', message: '答案保存失败，请重试'})
      }
    })
    // 点击交卷，先提交答题记录
    eventBus.$on('index.submitExam', async () => {
      if (this.isSubmitting || this.isSubLoading) return
      this.isSubLoading = true
      try {
        if (this.hasPendingAnswer()) await this.submitRecord()
        eventBus.$emit('header.showDialog', this.answerCardDetail) // 确认交卷的弹窗
      } catch {
        this.$message({type: 'error', message: '当前答案保存失败，请重试后交卷'})
      } finally {
        this.isSubLoading = false
      }
    })
    // 考试时间到，自动交卷
    eventBus.$on('index.autoSubmitExam', async () => {
      if (this.isSubLoading || this.isSubmitting) return
      this.isSubLoading = true
      try {
        if (this.hasPendingAnswer()) await this.submitRecord()
        this.isSubLoading = false
        await this.submitExam()
      } catch {
        this.isSubLoading = false
        this.$message({type: 'error', message: '当前答案保存失败，暂未交卷，请重试'})
      }
    })
    // 当前题目的答案
    eventBus.$on('index.setCurAnswer', (e: any) => {
      this.curAnswer = e
    })
    // 练习模式提交答案
    eventBus.$on('index.practice.submitRecord', async () => {
      if (!this.hasPendingAnswer() || this.isSubLoading || this.isSubmitting) return
      this.isSubLoading = true
      try {
        const subject = await this.submitRecord()
        this.$store.commit('SET_CUR_SUBJECY', JSON.parse(JSON.stringify(subject)))
      } catch {
        this.$message({type: 'error', message: '答案提交失败，请重试'})
      } finally {
        this.isSubLoading = false
      }
    })
    // 考试模式提交答案
    eventBus.$on('index.exam.submitRecord', async (subject: any) => {
      if (this.isSubLoading || this.isSubmitting) return
      this.isSubLoading = true
      try {
        if (this.hasPendingAnswer()) await this.submitRecord()
        this.$store.commit('SET_CUR_SUBJECY', subject)
      } catch {
        this.$message({type: 'error', message: '答案保存失败，请重试'})
      } finally {
        this.isSubLoading = false
      }
    })
  }

  hasPendingAnswer(): boolean {
    return Boolean(this.curAnswer && this.curAnswer.material_id)
  }

  async initPage() {
    this.isLoading = true
    try {
      await this.startExam()
      await Promise.all([this.getExamDetail(), this.getAnswerList()])
      this.answerCardDetail.answer_card.forEach((item: any) => {
        item.childId = item.id
      })
      this.$store.commit('SET_CARD_LIST', this.answerCardDetail.answer_card)
      this.getSubject(this.curSubId || this.answerCardDetail.answer_card[0].id) // 获取第一题
    } catch (e) {
      this.isLoading = false
      if (!this.errorObj && e) this.errorObj = e
    }
  }

  // 获取试题详情
  async getExamDetail() {
    return getExamDetail(this.id).then(res => {
      this.examDetail = res
      utils.windowTitle(this.examDetail.name)
      this.$store.commit('SET_EXAM_DETAIL', JSON.parse(JSON.stringify(this.examDetail)))
    }).catch(e => {
      return Promise.reject(e.errorObj || e)
    })
  }

  // 获取答题卡详情
  getAnswerList() {
    return getAnswerDetail(this.id).then((res: any) => {
      if (res && res.answer_card && res.answer_card.length > 0) {
        res.answer_card.map((item:any, index:any) => {
          item.childId = item.id
          if (index === 0) {
            item.seq = item.type === 'rich_text' ? 0 : 1
          } else {
            item.seq = item.type === 'rich_text' ? res.answer_card[index - 1].seq : res.answer_card[index - 1].seq + 1
          }
        })
        this.answerCardDetail = res
      } else {
        return Promise.reject({
          imgName: 'box-empty',
          m: '暂时没有题目',
          btns: [{
            text: '重新加载',
            action: 'reload'
          }, {
            text: '返回首页',
            action: 'toHome',
            cls: 'link'
          }]
        })
      }
    }).catch((e: any) => {
      return Promise.reject(e.errorObj || e)
    })
  }

  // 获取题目
  getSubject(questionId: any) {
    getSubject(questionId).then(res => {
      if (res.answer && res.answer.length > 0 && res.content && Array.isArray(res.content.options)) {
        res.content.options.forEach((r: any) => {
          res.answer.forEach((r1: any) => {
            if (String(r.id) === String(r1)) {
              if (r.is_correct === false) {
                r.status = 'error'
              } else {
                r.status = 'correct'
              }
            }
          })
        })
      }
      this.handleSubject(res, this.answerCardDetail.answer_card)
      this.isLoading = false
      this.isSubLoading = false
    }).catch(e => {
      this.isLoading = false
      this.isSubLoading = false
      this.errorObj = e.errorObj || e
    })
  }

  // 开始考试
  startExam() {
    if (this.renderType === 'analysis') {
      return true
    } else {
      return startExam(this.id).catch(e => {
        const errorCode = e && e.response && e.response.data && e.response.data.error
        if (errorCode === '40202') { // 未订阅且不是试学
          this.toContentDetail()
        } else if (e.errorObj) {
          this.isLoading = false
          this.errorObj = e.errorObj
        }
        return Promise.reject(e.errorObj || e)
      })
    }
  }

  // 结束考试
  async endExam(): Promise<boolean> {
    try {
      await finishExam(this.id)
      // 跳转到成绩单页面
      this.isSubLoading = false
      if (this.source !== 'autoPaper' && this.contentType && !this.examDetail.has_subscribed) {
        this.toContentDetail()
        return true
      }
      await this.$router.replace({
        name: 'examResult',
        params: {id: this.id},
        query: {
          contentId: this.contentId,
          contentType: this.contentType,
          examType: this.examType,
          source: this.source
        }
      })
      return true
    } catch {
      this.isSubLoading = false
      this.$message({type: 'error', message: '交卷失败，请稍后重试'})
      return false
    }
  }

  // 提交答题记录
  async submitRecord(): Promise<any> {
    if (!this.hasPendingAnswer()) return this.curSubjectInfo
    const currentAnswer = this.curAnswer
    const temp = [currentAnswer]
    const index = this.examList.findIndex((v: any) => v.childId === currentAnswer.material_id)
    const subjectInfo = this.examList[index]
    if (!subjectInfo) return Promise.reject(new Error('current subject not found'))
    await submitRecord(this.id, {answers: temp})
    // 提交答题记录成功后，把用户答案放到题目的数据中，更新题目列表。
    subjectInfo.answer = currentAnswer.value
    subjectInfo.isAnswer = true
    if (this.curAnswer === currentAnswer) this.curAnswer = null
    this.$store.dispatch('setSubjectItem', subjectInfo)
    try {
      await this.getAnswerList()
    } catch {
      // 答案已经提交成功，答题卡刷新失败时使用本地状态，不阻断切题或交卷。
      const card = this.answerCardDetail.answer_card && this.answerCardDetail.answer_card.find((item: any) => {
        return String(item.id) === String(currentAnswer.material_id)
      })
      if (card && !card.has_answered) {
        card.has_answered = true
        this.answerCardDetail.answered_count = Number(this.answerCardDetail.answered_count || 0) + 1
        this.answerCardDetail.skip_count = Math.max(0, Number(this.answerCardDetail.skip_count || 0) - 1)
      }
    }
    return subjectInfo
  }

  // 交卷
  async submitExam() {
    if (this.isSubmitting) return
    this.isSubmitting = true
    this.isSubLoading = true
    const success = await this.endExam()
    if (!success) this.isSubmitting = false
  }

  toContentDetail() {
    let name = ''
    switch (this.contentType) {
      case 'provingground': // 试炼场
        name = 'Briprovingground'
        break
      case 'trainingcampclass': // 训练营
        name = 'Britrainingcampclass'
        break
      case 'course': // 课程
        name = 'Bricourse'
        break
    }
    if (name) {
      this.$router.replace({name, params: {id: this.contentId}})
    } else {
      this.$router.replace({name: 'autoPaper'})
    }
  }

  beforeDestroy() {
    eventBus.$off()
  }
}
